import { DesktopAlertIcon, ProductUpdatesListIcon, SettingsIcon } from '@onsolve/onsolve-ui-components';
import { defineMessage } from '@lingui/macro';
export const AnnouncementTypesLookup = {
    maintenance: {
        Icon: SettingsIcon,
        color: 'catalina-blue',
        description: defineMessage({ message: 'New feature, release notes, updates, etc...' }),
        title: defineMessage({ message: 'Maintenance' }),
        announcementId: 'maintenance',
    },
    productupdate: {
        Icon: ProductUpdatesListIcon,
        color: 'wave-blue',
        description: defineMessage({ message: 'New feature, release notes, updates, etc...' }),
        title: defineMessage({ message: 'Product Update' }),
        announcementId: 'productupdate',
    },
    webinar: {
        Icon: DesktopAlertIcon,
        color: 'curious-purple',
        description: defineMessage({ message: 'Training courses, Live Demos, etc...' }),
        title: defineMessage({ message: 'Webinar' }),
        announcementId: 'webinar',
    },
};
